module.exports = __webpack_public_path__ + "static/BillsbyOG-19cf36f507b4af2d093b08b93dd82887.png";